const safeObject = value =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {};
const safeArray = value => (Array.isArray(value) ? value : []);
const normalizeString = value => (typeof value === 'string' ? value.trim() : '');

const userPrivateData = currentUser =>
  currentUser?.attributes?.profile?.privateData ||
  currentUser?.attributes?.privateData ||
  currentUser?.privateData ||
  {};

const normalizeEmailState = value => {
  const source = safeObject(value);
  return {
    eventId: normalizeString(source.eventId) || null,
    status: normalizeString(source.status).toLowerCase() || null,
    sentAt: source.sentAt || null,
    skippedAt: source.skippedAt || null,
    failedAt: source.failedAt || null,
    reason: normalizeString(source.reason) || null,
    messageId: normalizeString(source.messageId) || null,
  };
};

const normalizeContext = value => {
  const source = safeObject(value);
  return Object.keys(source).reduce((acc, key) => {
    const normalizedKey = normalizeString(key);
    if (!normalizedKey) {
      return acc;
    }

    acc[normalizedKey] = source[key];
    return acc;
  }, {});
};

const normalizeNumber = value => {
  if (Number.isInteger(value) && value >= 0) {
    return value;
  }
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
};

const normalizeNotificationEvent = value => {
  const source = safeObject(value);
  return {
    eventId: normalizeString(source.eventId) || null,
    type: normalizeString(source.type) || null,
    transactionId: normalizeString(source.transactionId) || null,
    listingId: normalizeString(source.listingId) || null,
    listingTitle: normalizeString(source.listingTitle) || '',
    transition: normalizeString(source.transition) || null,
    actorRole: normalizeString(source.actorRole) || null,
    recipientRole: normalizeString(source.recipientRole) || null,
    createdAt: source.createdAt || null,
    quantity: normalizeNumber(source.quantity),
    amount: normalizeNumber(source.amount),
    currency: normalizeString(source.currency) || null,
    context: normalizeContext(source.context),
    email: normalizeEmailState(source.email),
  };
};

export const getMarketplaceNotifications = currentUser => {
  const source = safeObject(userPrivateData(currentUser)?.marketplaceNotifications);
  const events = safeArray(source.events)
    .map(normalizeNotificationEvent)
    .filter(event => event.eventId);
  const latestEventId = normalizeString(source.latestEventId) || events.at(-1)?.eventId || null;

  return {
    latestEventId,
    events,
  };
};

export const getLatestMarketplaceNotification = currentUser => {
  const notifications = getMarketplaceNotifications(currentUser);
  if (!notifications.latestEventId) {
    return null;
  }

  return (
    notifications.events.find(event => event.eventId === notifications.latestEventId) ||
    notifications.events.at(-1) ||
    null
  );
};

export const getLatestMarketplaceNotificationEventId = currentUser => {
  return getLatestMarketplaceNotification(currentUser)?.eventId || null;
};
